<template>
	<div>
    <v-card class="mt-4" v-if="userDocuments && userDocuments.length > 0">
      <library-list-read-only
        :documents="userDocuments"
        color="blue"
        :header="userRoleDisplayName"
      />
    </v-card>
    <v-card class="mt-4" v-else>
      <v-card-text class="text-center">
        Brak dokumentów dla Twojej roli.
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
	import LibraryListReadOnly from "./components/LibraryListReadOnly";
	import {Library} from "@/api/generated/Library";

	export default {
		name: "LibraryViewReadOnly",

		components: {LibraryListReadOnly},

		computed: {
			userDocuments() {
				return this.documents || [];
			},
			userRoleDisplayName() {
				return this.getRoleDisplayName();
			}
		},

		methods: {
			getRoleDisplayName() {
                if(this.roles.isLocalAdministrator()){
                    return "Biblioteka: Administrator lokalny";
                }
                if(this.roles.isDepartmentEmployee()){
                    return "Biblioteka: Pracownik departamentu";
                }
                if(this.roles.isAgencyEmployee()){
                    return "Biblioteka: Pracownik placówki";
                }
                if(this.roles.isExpert()){
                    return "Biblioteka: Ekspert";
                }
                if(this.roles.isBidder()){
                    return "Biblioteka: Oferent";
                }
                if(this.roles.isSubBidder()){
                    return "Biblioteka: Oferent - subkonto";
                }
                if(this.roles.isVolunteer()){
                    return "Biblioteka: Wolontariusz";
                }
                if(this.roles.isViewer()){
                    return "Biblioteka: Przeglądający";
                }
                return "Biblioteka: Nieznana rola";
			}
		},

		data() {
			return {
				documents: []
			};
		},

		created() {
			loadLibraries(this);
		},
	};

	function loadLibraries(ctx) {
		Library.getMyRole(ctx, 
			successResponse => {
				ctx.documents = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować dokumentów", errorResponse);
			});
	}

</script>

<style scoped>
</style>